import React from "react";

type PasswordInputProps = {
    name: string,
    label: string,
    onChange: any,
    placeholder: string,
    className: string,
    value: any,
    error: any,
}

const PasswordInput = ({
    name,
    label,
    onChange,
    placeholder,
    className,
    value,
    error,
}: PasswordInputProps) => {
    let wrapperClass = "form-group";
    if (error && error.length > 0) {
        wrapperClass += " has-error";
    }

    return (
        <div className={wrapperClass}>
            <label htmlFor={name}>{label}</label>
            <div className="field">
                <input
                    type="password"
                    name={name}
                    className={className}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
                {/* {error && <div className="alert alert-danger">{error}</div>} */}
            </div>
        </div>
    );
};

export default PasswordInput;